import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import RcSeparator from '@components/RcSeparator/RcSeparator.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'RcDropdownSeparator',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RcSeparator, { decorative: false }))
}
}

})